export default __webpack_public_path__ + "static/media/photo.f79f324f.jpeg";